import React from 'react'

function Footer() {
    return (
        <footer className="page-footer">
            <div className="footer-copyright">
                <div className="container center">
                    © 2022 mspuz dev
                </div>
            </div>
        </footer>
    )
}

export default Footer